import React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { useAppSelector } from '../../store/hooks';
import { LoadingSpinner } from '../common';

interface PublicRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

interface PublicRouteLocationState {
  from?: {
    pathname?: string;
  };
}

export const PublicRoute: React.FC<PublicRouteProps> = ({
  children,
  redirectTo = '/dashboard',
}) => {
  const { isAuthenticated, isLoading } = useAppSelector((state) => state.auth);
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    const from =
      (location.state as PublicRouteLocationState | null)?.from?.pathname ||
      redirectTo;
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};
